let numberList = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']

export function isAngleMark(row) {
  return !(row.isCustomList == 'Y' && row.questionTypeSecondCode)
}
// 判断文件是否是图片类型
export function judgeIfImg(fileName) {
  let imgArr = ["png", "gif", "jpg", "jpeg"];
  let suffix = fileName.substring(fileName.lastIndexOf(".") + 1); // 获取文件路径后缀名
  if (imgArr.indexOf(suffix) != -1) {
    return true;
  }
  return false;
}
// 数组转文本
export function num2text(num) {
  if (typeof num != "number") {
    return 'error'
  }
  let numStr = num.toString();

  if (num <= 10) {
    return numberList[num]
  } else if (num > 10 && num < 100) {
    if (num % 10 == 0) {
      return numberList[numStr[0]] + '十'
    } else {
      return (numStr[0] == '1' ? '' : numberList[numStr[0]]) + '十' + numberList[numStr[1]]
    }
  } else {
    return "不考虑此范围";
  }
}



// WEBPACK FOOTER //
// ./src/filters/global.js